import { FC, Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { mainRoutes, dashBoardRoutes } from "./routes";
import { useAppSelector } from "../hooks/redux-hooks";
import { selectMainState } from "../store/slices/main";
import TagManager from "react-gtm-module";
import Splash from "../assets/icon/Splash";

const InternalRouter: FC = () => {
  // const { SEOSettingsDefault } = useAppSelector(selectMainState);
  //
  // useEffect(() => {
  //   // if (SEOSettingsDefault && SEOSettingsDefault.tagManagerId) {
  //   //   TagManager.initialize({ gtmId: SEOSettingsDefault.tagManagerId });
  //   // }
  // }, [SEOSettingsDefault]);

  return (
    <Suspense fallback={null}>
      <Routes>
        {Object.values(mainRoutes).map((r, index) => {
          if (r.title === mainRoutes.home.title) {
            return (
              <Route key={index} path={r.path} element={<r.element />}>
                {Object.values(dashBoardRoutes).map(
                  (dashBoardRoutes, index) => {
                    return (
                      <Route
                        key={index}
                        path={dashBoardRoutes.path}
                        element={<dashBoardRoutes.element />}
                      />
                    );
                  }
                )}
              </Route>
            );
          }
          return (
            <Route key={index + r.path} path={r.path} element={<r.element />} />
          );
        })}
      </Routes>
    </Suspense>
  );
};
export default InternalRouter;
